import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class UserProfile extends RestApiModel {
  static getResourceEndpoint() {
    return '/user/profile';
  }

  static getRoleTypes() {
    return api.get(this.getResourceEndpoint() + '/role-types');
  }

}

export default UserProfile;
